// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"fa4da377","332":"6a6baf63","856":"e39273cd","952":"73c6b452"}[chunkId] + ".chunk.js";
};